import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './contexts/AuthContext';
import { GlobalStyles } from './components/GlobalStyles';
import { PageLoader } from './components/PageLoader';
import { Header } from './components/Header';
import { Hero } from './components/sections/Hero';
import { AnnouncementBar } from './components/sections/AnnouncementBar';
import { HeroBannerSlider } from './components/sections/HeroBannerSlider';
import { SolutionsSection } from './components/sections/SolutionsSection';
import { ProcessSection } from './components/sections/ProcessSection';
import { BlogPage } from './components/sections/BlogPage';
import { TechnologySection } from './components/sections/TechnologySection';
import { KitSection } from './components/sections/KitSection';
import { PlansSection } from './components/sections/PlansSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { FAQSection } from './components/sections/FAQSection';
import { AboutSection } from './components/sections/AboutSection';
import { ContactSection } from './components/sections/ContactSection';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { DS } from './components/ds';
import { PromoModal } from './components/PromoModal';
type View = 'landing' | 'nosotros' | 'faq' | 'blog';

// Reemplaza con el Client ID de OAuth de tu proyecto en Google Cloud Console
// (APIs & Services → Credentials → OAuth 2.0 Client IDs) para que "Inicia
// sesión con Google" pueda autenticar usuarios reales.
const GOOGLE_CLIENT_ID = '515245851409-g1irvbka15d3uonrqntdfa45215fi3nd.apps.googleusercontent.com';
export function App() {
  const [view, setView] = useState<View>('landing');
  useLayoutEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    const scrollToHero = () => window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    scrollToHero();
    const frame = window.requestAnimationFrame(scrollToHero);
    window.addEventListener('pageshow', scrollToHero);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('pageshow', scrollToHero);
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);
  const scrollTo = useCallback((id: string) => {
    if (id === 'nosotros') {
      setView('nosotros');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    if (id === 'faq') {
      setView('faq');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    if (id === 'blog') {
      setView('blog');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    if (id === 'top') {
      setView('landing');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    if (view !== 'landing') {
      setView('landing');
      window.setTimeout(() => {
        const element = document.getElementById(id);
        if (!element) return;
        window.scrollTo({
          top: element.getBoundingClientRect().top + window.scrollY - 68,
          behavior: 'smooth'
        });
      }, 80);
      return;
    }
    const element = document.getElementById(id);
    if (!element) return;
    window.scrollTo({
      top: element.getBoundingClientRect().top + window.scrollY - 68,
      behavior: 'smooth'
    });
  }, [view]);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('section-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.08
    });
    const sections = document.querySelectorAll('section[id]');
    sections.forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, [view]);
  const goHome = () => {
    setView('landing');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID} data-id="element-0" data-mp="m5ngxes7ovrm">
      <AuthProvider data-id="element-1" data-mp="h72po4uxtmfb">
        <div className="alinova-root" style={{
        fontFamily: DS.font.body,
        background: DS.color.ivory
      }} data-id="element-2" data-mp="h6kn6qhombyy">
          <PageLoader data-id="element-3" data-mp="ca2j7su6ehno" />
          <GlobalStyles data-id="element-4" data-mp="c6epasktjt8f" />
          <Header onNav={scrollTo} currentView={view} data-id="element-5" data-mp="19wjfcur6ap7u" />

      {view === 'nosotros' ? <main data-id="element-6" data-mp="14x6gtcqxvtpf">
          <AboutSection onBack={goHome} data-id="element-7" data-mp="14wez95u6fwi5" />
        </main> : view === 'faq' ? <main data-id="element-8" data-mp="zxk372778bg3">
          <FAQSection onBack={goHome} data-id="element-9" data-mp="zx2augnnqhdg" />
        </main> : view === 'blog' ? <main data-id="element-10" data-mp="vwicj9rcl7pq">
          <BlogPage onBack={goHome} data-id="element-11" data-mp="vx080466rhwl" />
        </main> : <main data-id="element-12" data-mp="vykzfkx7ekq8">
          <AnnouncementBar data-id="element-13" data-mp="3knt1x1h44vpg" />
          <HeroBannerSlider data-id="element-14" data-mp="3kp426rbcnlbt" />
          <Hero onCTA={scrollTo} data-id="element-15" data-mp="3kpdx8tb94iod" />
          <SolutionsSection onCTA={scrollTo} data-id="element-16" data-mp="3gmpkiajf2rm4" />
          <ProcessSection onCTA={scrollTo} data-id="element-17" data-mp="3glo5juza5kz4" />
          <TechnologySection data-id="element-18" data-mp="1w4f4gqt7xhon" />
          <KitSection onCTA={scrollTo} data-id="element-19" data-mp="1w582n3e42yv6" />
          <PlansSection data-id="element-20" data-mp="1w69lhu1dcpng" />
          <TestimonialsSection data-id="element-21" data-mp="2060d1zypz9t1" />
          <FinalCTA onCTA={scrollTo} data-id="element-22" data-mp="2071z0zh9xgpj" />
          <ContactSection data-id="element-23" data-mp="203xn1fxkhgob" />
        </main>}

      <Footer onNav={scrollTo} data-id="element-24" data-mp="254v39mz0o0n6" />

      <div style={{
          position: 'fixed',
          bottom: '28px',
          right: '28px',
          zIndex: 9998
        }} onMouseEnter={event => toggleWhatsAppLabel(event.currentTarget, true)} onMouseLeave={event => toggleWhatsAppLabel(event.currentTarget, false)} data-id="element-25" data-mp="253k2lw0vb90a">
        <div className="wa-label" aria-hidden="true" style={{
            position: 'absolute',
            right: '78px',
            top: '50%',
            transform: 'translateY(-50%) translateX(8px)',
            background: DS.color.inkDeep,
            color: DS.color.aquaLight,
            fontFamily: DS.font.body,
            fontSize: '0.78rem',
            fontWeight: 600,
            letterSpacing: '0.06em',
            whiteSpace: 'nowrap',
            padding: '8px 14px',
            borderRadius: '8px',
            opacity: 0,
            pointerEvents: 'none',
            transition: `opacity 0.22s ${DS.ease.smooth}, transform 0.22s ${DS.ease.smooth}`,
            boxShadow: DS.shadow.card
          }} data-id="element-26" data-mp="2jt83iw5505nh">
          Escríbenos
          <span style={{
              position: 'absolute',
              right: '-6px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: 0,
              height: 0,
              borderTop: '5px solid transparent',
              borderBottom: '5px solid transparent',
              borderLeft: `6px solid ${DS.color.inkDeep}`
            }} data-id="element-27" data-mp="25snui7ewhu8r" />
        </div>

        <a href={DS.wa} target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp" style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            background: '#00AAD4',
            border: `1.5px solid ${DS.color.aqua}`,
            boxShadow: '0 10px 30px rgba(0, 170, 212, 0.35)',
            textDecoration: 'none',
            transition: `transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)`,
            position: 'relative'
          }} onFocus={event => toggleWhatsAppLabel(event.currentTarget.parentElement, true)} onBlur={event => toggleWhatsAppLabel(event.currentTarget.parentElement, false)} onMouseEnter={event => {
            event.currentTarget.style.transform = 'scale(1.15)';
            event.currentTarget.style.boxShadow = '0 14px 40px rgba(0, 170, 212, 0.45)';
          }} onMouseLeave={event => {
            event.currentTarget.style.transform = 'scale(1)';
            event.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 170, 212, 0.35)';
          }} data-id="element-28" data-mp="2pig3c960idak">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true" data-id="element-29" data-mp="30taufqm7380e">
            <path d="M16 3C9.373 3 4 8.373 4 15c0 2.385.668 4.61 1.832 6.505L4 29l7.697-1.807A11.94 11.94 0 0016 27c6.627 0 12-5.373 12-12S22.627 3 16 3z" fill="white" opacity="0.2" data-id="element-30" data-mp="2vx27hr1raaio" />
            <path d="M16 3C9.373 3 4 8.373 4 15c0 2.385.668 4.61 1.832 6.505L4 29l7.697-1.807A11.94 11.94 0 0016 27c6.627 0 12-5.373 12-12S22.627 3 16 3z" stroke="white" strokeWidth="1.2" fill="none" data-id="element-31" data-mp="2hw9fbcyxfriq" />
            <path d="M22.003 18.837c-.306-.153-1.809-.893-2.089-.994-.28-.1-.484-.153-.688.153-.203.306-.79.994-.968 1.198-.178.203-.356.229-.662.076-.306-.153-1.292-.476-2.461-1.518-.91-.811-1.524-1.813-1.702-2.119-.178-.306-.019-.471.134-.623.137-.137.306-.357.459-.535.153-.178.204-.306.306-.51.102-.203.051-.382-.025-.535-.077-.153-.688-1.66-.942-2.272-.248-.596-.5-.515-.688-.524l-.586-.01c-.203 0-.535.077-.815.382-.28.306-1.07 1.045-1.07 2.549s1.096 2.957 1.248 3.161c.153.203 2.156 3.291 5.226 4.615.73.315 1.3.503 1.744.644.733.233 1.4.2 1.927.121.588-.088 1.809-.74 2.064-1.454.255-.714.255-1.326.178-1.454-.077-.127-.28-.203-.586-.357z" fill="white" data-id="element-32" data-mp="284ltpsp1x4p6" />
          </svg>
          <span aria-hidden="true" style={{
              position: 'absolute',
              inset: '-4px',
              borderRadius: '50%',
              border: `1px solid ${DS.color.aqua}`,
              animation: 'waPulse 2.5s ease-out infinite',
              pointerEvents: 'none',
              opacity: 0.4
            }} data-id="element-33" data-mp="3m6b74ahu9ucq" />
        </a>
      </div>
      <PromoModal data-id="element-34" data-mp="33ftes70x50rw" />
        </div>
      </AuthProvider>
    </GoogleOAuthProvider>;
}
function toggleWhatsAppLabel(container: HTMLElement | null, isVisible: boolean) {
  const label = container?.querySelector<HTMLElement>('.wa-label');
  if (!label) return;
  label.style.opacity = isVisible ? '1' : '0';
  label.style.transform = isVisible ? 'translateY(-50%) translateX(0)' : 'translateY(-50%) translateX(8px)';
  label.style.pointerEvents = isVisible ? 'auto' : 'none';
}